import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SubscriberSearchResponseDto, SubscriberSelectComponent } from '../../../subscriber';
import { ReportParameterBase } from './report-parameter-base';

@Component({
    selector: 'app-subscriber-select-parameter',
    imports: [SubscriberSelectComponent],
    template: `
		<app-subscriber-select
			[subscriberKey]="subscriberKey()"
			[id]="parameterDefinition().key"
			[invalid]="isInvalid()"
			[disabled]="isDisabled()"
			(blur)="onBlur()"
			(loadingChange)="onLoadingChange($event)"
			(subscriberKeyChange)="onSubscriberKeyChange($event)"
			 />
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: SubscriberSelectParameterComponent,
		multi: true
	}]
})
export class SubscriberSelectParameterComponent extends ReportParameterBase<number | null> {
	subscriberKey = signal<number | null>(null);
	areAnyParamsLoading = this.reportWorkspace.areAnyParamsLoading;

	onSubscriberKeyChange = (subscriberKey: number | null) => {
		this.subscriberKey.set(subscriberKey);

		this.reportWorkspace.setSubscriberKey(subscriberKey);
		
		this.onChange(subscriberKey);
		this.markTouchedIfNotResetting();
	}

	override isDisabled = computed(() => this.reportWorkspace.isReportRunning() || this.isFormControlDisabled() || this.areAnyParamsLoading());

	onLoadingChange = (isLoading: boolean) => {
		this.reportWorkspace.setParamLoading(this.parameterDefinition().key, isLoading);
	}

	onBlur() {
		this.onTouched();
	}

    // CVA callbacks
    writeValue(obj: number | null): void {
        this.subscriberKey.set(obj);
    }
}
